import { Component, OnInit, Inject, forwardRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { DetailsService } from '../../providers/details.service';
import { APIService } from '../../providers/api.service';
import { SigninComponent } from '../../landing/signin/signin.component';
import * as $ from 'jquery';

@Component({
  selector: 'app-landing-success',
  templateUrl: './landing-success.component.html',
  styleUrls: ['./landing-success.component.css'],
  providers: [APIService, SigninComponent]
})

export class LandingSuccessComponent implements OnInit {
  currentYear: any;

  public footers = [
    { 'title': 'About', 'description': 'About Description', 'path': 'about' },
    { 'title': 'Blog', 'description': '', 'path': '' },
    { 'title': 'FAQ', 'description': 'faq Description', 'path': 'faq' },
    { 'title': 'Rules', 'description': 'rules Description', 'path': 'rules' },
    { 'title': 'Support', 'description': 'welcomeSupport Description', 'path': 'welcomeSupport' },
    { 'title': 'Terms & Conditions', 'description': 'legal Description', 'path': 'legal' },
    { 'title': 'Privacy Policy', 'description': 'privacyPolicy Description', 'path': 'privacyPolicy' }
  ];

  constructor(
    private APIService: APIService,
    private localStorageService: LocalStorageService,
    private detailsService: DetailsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    @Inject(forwardRef(() => SigninComponent)) public _parent: SigninComponent
  ) {
    this.currentYear = new Date().getFullYear();
  }

  ngOnInit() {
    var self = this
    if ((self.activatedRoute && self.activatedRoute.queryParams)) {

      self.activatedRoute.queryParams.subscribe(params => {
        var data = JSON.parse(window.localStorage.getItem("data"));
        if (params && params.mode) {
          var mode = params.mode ? params.mode : ""
          if (mode !== "") {
            if (mode == "fb" || mode == "google") {
              self.localStorageService.add('email', data.email)
              self.localStorageService.add('userId', data.userid)
              self.localStorageService.add('userName', data.userName)
              self.localStorageService.add('token', data.accessToken);
              // $.get("https://statementgames.misaic.net/api/tc/?method=ordersubmit&productid=11&fname=" + data.firstName + "&lname=" + data.lastName + "&email=" + data.email + "&pubkey=6fDq8St7", function (resultData) {
              //   console.log(resultData);
              //   $.get("https://statementgames.misaic.net/api/tc/?method=applytag&tagid=69&tagval=Member&fname=" + data.firstName + "&lname=" + data.lastName + "&email=" + data.email + "&pubkey=6fDq8St7", function (data1) {
              //     console.log(data1);
              //   });
              // });
              var userType = data.userType;
              self.APIService.doApiCall(function (data) {
                if (data.Data.roleId === self.detailsService.loginAdmin || data.Data.roleId === self.detailsService.loginSuperAdmin) {
                  self.router.navigate(['/dashboard/home']);
                  window.localStorage.removeItem("data")
                } else if (data.Data.roleId === self.detailsService.loginUser) {
                  window.localStorage.removeItem("data")
                  var contestid = self.localStorageService.get('contestid');
                  var url = window.location.origin + "/";
                  if (contestid) {
                    self._parent.checkPrivateContest();
                  }
                  else {
                    var compaignUrl = self.localStorageService.get('compaignUrl');
                    if (userType == 'newUser') {
                      if (compaignUrl)
                        window.location.href = url + "landing/signup/success" + compaignUrl;
                      else
                        window.location.href = url + "landing/signup/success";
                    }
                    else {
                      if (compaignUrl)
                        window.location.href = url + "landing/signin/success" + compaignUrl;
                      else
                        window.location.href = url + "landing/signin/success";
                    }
                    //setTimeout(function () {
                    if (compaignUrl) {
                      window.location.href = self.localStorageService.get('newUrl') + "user/lobby";
                    }
                    else {                  
                      window.location.href = url + "user/lobby";

                    }
                    // }, 1000);
                  }
                }
              }, 'api/profile/userinfo?email=' + data.email, 'GET', null, null);
            } else if (mode == "twitter") {
              self.localStorageService.add('email', data.email)
              self.localStorageService.add('userId', data.userid)
              self.localStorageService.add('userName', data.userName)
              self.localStorageService.add('token', data.accessToken)
              self.APIService.doApiCall(function (data) {
                if (data.Data.roleId === self.detailsService.loginAdmin || data.Data.roleId === self.detailsService.loginSuperAdmin) {
                  self.router.navigate(['/dashboard/home']);
                  window.localStorage.removeItem("data")
                } else if (data.Data.roleId === self.detailsService.loginUser) {
                  self.router.navigate(['/user/lobby']);
                  window.localStorage.removeItem("data")
                }
              }, 'api/profile/userinfo?email=' + data.email, 'GET', null, null);
            }
          }
        }
      });
    }
  }

  loadFooterContent(footer) {
    if (footer.title !== 'Blog') {
      this.router.navigate(['welcome', footer.path]);
    } else {
      window.open('http://blog.statementgames.com', '_self');
    }

  }

}
